import { toast, ToastContainer } from 'react-toastify'
import { createContext } from 'react'
import { ToastOptions, TypeOptions } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import './Notify.css'

const initState: ToastOptions = {
  position: 'bottom-left',
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
  theme: 'colored',
  closeButton: false
}

export const NotifyContext = createContext({
  ...initState,
  notify: (message, type?: TypeOptions, options?: any) => {},
  loadify: (promise) => { Promise.resolve() },
  loading: (message?: string) => '' as any,
  update: (id: string, options: any) => {}
})

const NotifyProvider = ({ children }) => {
  const notify = (message: any, type?: TypeOptions, options?: any) => {
    toast(message || 'Internal Server Error', { ...initState, ...options, type })
  }

  const loadify = (promise: Promise<Function>) => {
    toast.promise(promise, {
      pending: 'Loading',
      success: {
        render({data}: {data: any}) {
          return data?.data?.msg || 'Success'
        }
      },
      error: {
        render({data}: {data: any}) {
          return data?.response?.data?.msg || 'Internal Server Error'
        }
      }
    }, {
      ...initState,
      theme: 'light',
    }
    )
  }

  const loading = (message?: string) => toast.loading(message || 'Loading', { ...initState, theme: 'light' })

  const update = (id: string, options: any) => toast.update(id, {...initState, ...options, theme: 'light'})

  return (
    <NotifyContext.Provider value={{ ...initState, notify, loadify, loading, update }}>
      {children}
      <ToastContainer className="toast-container" limit={5} newestOnTop />
    </NotifyContext.Provider>
  )
}

export default NotifyProvider
